(function () {
  var WORKER_URL = "https://fce-quote-form.fuelcellsetc.workers.dev";
  var form = document.getElementById("fce-quote-form");
  if (!form) return;
  var msg = document.getElementById("fce-msg");
  var btn = document.getElementById("fce-submit");
  var cat = document.getElementById("fce-category");

  try {
    var params = new URLSearchParams(window.location.search);
    var q = (params.get("category") || "").trim();
    if (q && cat) {
      var map = { mea: "MEA", gde: "GDE", gdl: "GDL", membrane: "Membrane", membranes: "Membrane", catalyst: "Catalyst", catalysts: "Catalyst", hardware: "Hardware" };
      var val = map[q.toLowerCase()] || q;
      for (var i = 0; i < cat.options.length; i++) {
        if (cat.options[i].value === val) { cat.value = val; break; }
      }
    }
  } catch (e) {}

  function show(ok, text) {
    msg.className = "fce-msg " + (ok ? "ok" : "err");
    msg.textContent = text;
  }

  form.addEventListener("submit", function (ev) {
    ev.preventDefault();
    msg.className = "fce-msg";
    msg.textContent = "";

    var email = (form.email.value || "").trim();
    var category = form.category.value;
    if (!email || email.indexOf("@") < 1) {
      show(false, "Please enter a valid reply email.");
      form.email.focus();
      return;
    }
    if (!category) {
      show(false, "Please select a category.");
      form.category.focus();
      return;
    }

    var tokenEl = form.querySelector("[name=cf-turnstile-response]");
    var token = tokenEl && tokenEl.value;
    if (!token) {
      show(false, "Please complete the captcha.");
      return;
    }

    var fd = new FormData();
    fd.append("email", email);
    fd.append("name", (form.name.value || "").trim());
    fd.append("company", (form.company.value || "").trim());
    fd.append("phone", (form.phone.value || "").trim());
    fd.append("category", category);
    fd.append("quantity", (form.quantity.value || "").trim());
    fd.append("details", (form.details.value || "").trim());
    fd.append("specs", (form.specs.value || "").trim());
    fd.append("cf-turnstile-response", token);

    var files = form.files.files;
    for (var i = 0; i < files.length; i++) fd.append("files", files[i]);

    btn.disabled = true;
    btn.textContent = "Sending…";

    fetch(WORKER_URL, { method: "POST", body: fd, credentials: "omit" })
      .then(function (r) {
        return r.json().then(function (j) { return { status: r.status, j: j }; });
      })
      .then(function (res) {
        if (res.j && res.j.ok) {
          show(true, res.j.message || "Thank you. We received your quote request and will reply within 2 business days.");
          form.reset();
          if (window.turnstile) {
            try { window.turnstile.reset(); } catch (e) {}
          }
        } else {
          show(false, (res.j && res.j.error) || "Something went wrong. Please try again.");
          if (window.turnstile) {
            try { window.turnstile.reset(); } catch (e) {}
          }
        }
      })
      .catch(function () {
        show(false, "Network error. Please try again or use Contact Us.");
        if (window.turnstile) {
          try { window.turnstile.reset(); } catch (e) {}
        }
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = "Submit quote request";
      });
  });
})();
